import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMoveStart(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 5C6 4.44771 5.55228 4 5 4C4.44772 4 4 4.44771 4 5L4 19C4 19.5523 4.44772 20 5 20C5.55229 20 6 19.5523 6 19L6 5Z"
        fill="currentColor"
      />
      <path
        d="M8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071C13.0976 15.3166 13.0976 14.6834 12.7071 14.2929L11.4142 13L19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H11.4142L12.7071 9.70711C13.0976 9.31658 13.0976 8.68342 12.7071 8.29289C12.3166 7.90237 11.6834 7.90237 11.2929 8.29289L8.29289 11.2929Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
